// Vendor imports
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const extension = require('client-v2/common/utils/extension')
const tag = require('client-v2/common/utils/hyperscript')
const { useModalDepthScrollbarOffset } = require('client-v2/common/contexts/modal-depth')
// Sibling imports
const ToastsRecord = require('./record')
const ToastsNoticeRecord = require('./records/notice')

const bem = BemEntity('Toasts')

function Toasts(props) {
  const blockRef = React.useRef()
  useModalDepthScrollbarOffset(blockRef)
  const { onDismiss } = props
  const handleNoticeClick = React.useCallback(
    event => {
      const { noticeId } = event.target.dataset
      onDismiss({ noticeId })
    },
    [ onDismiss ]
  )
  let style
  // Prevent mix-bar extension element from overlapping toasts
  const extensionEl = extension.getElement()
  if (extensionEl) {
    const extensionRect = extensionEl.getBoundingClientRect()
    if (extensionRect.height) {
      style = { marginTop: extensionRect.bottom }
    }
  }
  return (
    tag('div', {
      ref: blockRef,
      className: classNames(
        props.className,
        bem.block()
      ),
      style
    },
      props.notices.map(noticeProps => (
        tag(ToastsNotice, {
          key: noticeProps.id,
          onClick: handleNoticeClick,
          ...noticeProps
        })
      ))
    )
  )
}

module.exports = Toasts

function ToastsNotice(props) {
  return (
    tag('div', {
      className: bem.element('notice', {
        appearance: props.appearance,
        dismissed: props.dismissed
      }),
      dataset: {
        noticeId: props.id
      },
      onClick: props.onClick
    },
      typeof props.message === 'function'
      ? props.message()
      : props.message
    )
  )
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')

  Toasts.propTypes = {
    // Values
    className: PropTypes.string,
    notices: ToastsRecord.propTypes.notices,
    // Callbacks
    onDismiss: PropTypes.func.isRequired
  }

  ToastsNotice.propTypes = {
    // Values
    ...ToastsNoticeRecord.propTypes,
    // Callbacks
    onClick: PropTypes.func.isRequired
  }
}
